module.exports = __webpack_public_path__ + "img/mining-truck-icon.e9244e8c.svg";